module.exports = __webpack_public_path__ + "static/media/Raggruppa_68.000bda57.svg";